module.exports = __webpack_public_path__ + "img/calendar3-event.a2bb69b7.svg";